import React, { Component } from "react";
import { connect } from "react-redux";
import { getBulkreversalByID } from "../actions/actions";
import "antd/dist/antd.css";
import { Table, message, Modal } from "antd";
import { Resizable } from "react-resizable";
import PaginationComponent from "./PaginationComponent";

const ResizeableTitle = (props) => {
  const { onResize, width, ...restProps } = props;

  if (!width) {
    return <th {...restProps} />;
  }

  return (
    <Resizable width={width} height={0} onResize={onResize}>
      <th {...restProps} />
    </Resizable> 
  );
};

export class ViewBulkTransfersByBatchID extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        {
          title: "Payment Code",
          dataIndex: "paymentCode",
          width: 100,
        },
        {
          title: "Amount",
          dataIndex: "amount",
          width: 100,
        },
        {
          title: "Customer Id",
          dataIndex: "customerId",
          width: 150,
        },
        {
          title: "Customer Name",
          dataIndex: "customerName",
          width: 200,
        },
        {
          title: "Customer Email",
          dataIndex: "customerEmail",
          width: 150,
        },
        {
          title: "Customer Mobile",
          dataIndex: "customerMobile",
          width: 150,
        },
        {
          title: "QT Response Code",
          dataIndex: "qtResponseCode",
          width: 150,
        },
        {
          title: "WebPay Response Code",
          dataIndex: "webPayResponseCode",
          width: 100,
        },
        {
          title: "Status",
          dataIndex: "status",
          width: 150,
        },
        {
          title: "Transaction Ref",
          dataIndex: "transactionRef",
          width: 150,
        },
        {
          title: "WebPay Response Description",
          dataIndex: "webPayResponseDescription",
          width: 200,
        },
        {
          title: "Gateway Response Code",
          dataIndex: "gatewayResponseCode",
          width: 150,
        },
        {
          title: "Date Of Payment",
          dataIndex: "dateOfPayment",
          width: 150,
        },
        {
          title: "Session Id",
          dataIndex: "sessionId",
          width: 150,
        },
        {
          title: "Reversal Status",
          dataIndex: "reversalStatus",
          width: 150,
        },
        {
          title: "Reversal Response Description",
          dataIndex: "reversalResponseDescription",
          width: 150,
        },
      ],
      data: [],
      pageSize: 10,
      pageNo: 1,
      total: 500,
    };

    this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
    this.onPaginationChange = this.onPaginationChange.bind(this);
    this.failAction = this.failAction.bind(this);
  }

  componentDidMount() {
    const payload = {
      data: {
        pageNo: 1,
        pageSize: 10,
        batchId: this.props.batchId,
      },
      failAction: this.failAction,
    };
    this.props.getBulkreversalByID(payload, (res) => {
      this.setState({
        data: res,
      });
    });
    
  }

  components = {
    header: {
      cell: ResizeableTitle,
    },
  };

  failAction() {
    message.error("Error processing request at the moment, please try again");
  }

  handleResize =
    (index) =>
    (e, { size }) => {
      this.setState(({ columns }) => {
        const nextColumns = [...columns];
        nextColumns[index] = {
          ...nextColumns[index],
          width: size.width,
        };
        return { columns: nextColumns };
      });
    };

  handlePageSizeChange(value) {
      const newPayload = {
        pageNo: 1,
        pageSize: Number(value),
        batchId: this.props.batchId,
      }
      this.setState({
        pageSize: newPayload.pageSize,
      });
      const payload = {
        data: newPayload,
        failAction: this.failAction,
      };
      this.props.getBulkreversalByID(payload, (res) => {
        this.setState({
          data: res,
        });
      });   
  }

  onPaginationChange(value) {
    const newPayload = { ...this.props.searchParam };
    newPayload.pageNo = Number(value);
    this.setState({
      pageNo: newPayload.pageNo,
      batchId: this.props.batchId,
    });
    const payload = {
      data: newPayload,
      failAction: this.failAction,
    };
    this.props.getBulkreversalByID(payload, (res) => {
      this.setState({
        data: res,
      });
    });
  }

  render() {
    const { bulkViewLoading, paginationDataViewBulk } = this.props;
    const columns = this.state.columns.map((col, index) => ({
      ...col,
      onHeaderCell: (column) => ({
        width: column.width,
        onResize: this.handleResize(index),
      }),
    }));

    return (
      <div>
      <Modal title={`Details of batch ${this.props.batchId || "" } uploaded by ${this.props.uploadedBy}`} Modal visible={this.props.isModalOpen}  width={1200} onCancel={this.props.handleCancel} onOk={this.props.handleCancel} centered>
        <br />
        <PaginationComponent
          onPaginationChange={(item) => this.onPaginationChange(item)}
          handlePageSizeChange={this.handlePageSizeChange}
          loading={bulkViewLoading}
          pageSize={paginationDataViewBulk.pageSize}
          total={paginationDataViewBulk.dataSize}
          showPageSize={true}
        />
        <Table
          bordered
          components={this.components}
          columns={columns}
          dataSource={this.state.data}
          loading={bulkViewLoading}
          pagination={false}
          style={{overflow: "scroll"}}
        />
        <PaginationComponent
          onPaginationChange={(item) => this.onPaginationChange(item)}
          handlePageSizeChange={this.handlePageSizeChange}
          loading={bulkViewLoading}
          pageSize={paginationDataViewBulk.pageSize}
          total={paginationDataViewBulk.dataSize}
          showPageSize={false}
        />
      </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    bulkTransactions: state.bulkTransactions,
    bulkViewLoading: state.bulkViewLoading,
    paginationDataViewBulk: state.paginationDataViewBulk,
    user: state.user,
    bulkTransactionsbyID: state.bulkTransactionsbyID
  };
};

export default connect(mapStateToProps, {
  getBulkreversalByID,
})(ViewBulkTransfersByBatchID);

